import { useMemo } from 'react';
import { ICartExperience } from 'types/cart';
import { CartPriceBooking } from 'types/cartPricing';
import {
  getStayPricesByTier,
  TimeFrameListing,
} from 'utils/cart/serverCartQuote';
import useServerCartQuote from './useServerCartQuote';

/**
 * The server's quote for a flexible or multi-day cart item: its line, and what one of each tier costs
 * for the whole booking by tier name. Both are undefined for any other item, and until the server has
 * quoted it, so callers fall back to the tier's own rate.
 */
const useCartItemStayPrices = (
  cartItem: ICartExperience | undefined,
  listing: TimeFrameListing | undefined | null,
): {
  line: CartPriceBooking | undefined;
  prices: Record<string, number> | undefined;
} => {
  const items = useMemo(
    () => (cartItem ? { [cartItem.cartItemId]: cartItem } : false),
    [cartItem],
  );
  const listings = useMemo(
    () =>
      cartItem && listing
        ? { [cartItem.listingId || cartItem.experienceId]: listing }
        : {},
    [cartItem, listing],
  );
  const { quote } = useServerCartQuote(items, listings);
  const line = cartItem ? quote?.lines[cartItem.cartItemId] : undefined;

  const prices = useMemo(
    () => (line ? getStayPricesByTier(line) : undefined),
    [line],
  );

  return { line, prices };
};

export default useCartItemStayPrices;
